module.exports = __webpack_public_path__ + "static/instagram-80da0d096bcb46afaaf7036af7c23616.png";